<aura-edit-wrapper [(isEditing)]="isEditing" (saved)="onSave($event)" #editWrapper="auraEditWrapper">
  @if (editWrapper.isEditing()) {
    <core-user-roles-form
      [dto]="currentRoles()"
      [allReadonly]="!editWrapper.isEditing()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <core-user-roles-display [currentRoles]="currentRoles()" />
  }
</aura-edit-wrapper>
